import styled from 'styled-components';

export const ItemWrapper = styled.div(() => ({
  display: 'inline-flex',
  zIndex: 0,
}));

export const ItemWrapperMargin = styled(ItemWrapper)(() => ({}));

interface WrapperProps {
  $hasShadow?: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ $hasShadow, theme: { color, size } }) => ({
    display: 'flex',
    alignItems: 'center',
    filter: $hasShadow
      ? `drop-shadow(0px 1px ${size.units(0.5)} ${color.shadow.primary.default(0.2)})`
      : undefined,

    [ItemWrapperMargin]: {
      marginLeft: size.units(-1),

      '&:first-child': {
        marginLeft: 0,
      },
    },
  }),
);
